import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=65d61d6a&scoped=true&"
import script from "./InformationCard.vue?vue&type=script&lang=js&"
export * from "./InformationCard.vue?vue&type=script&lang=js&"
import style0 from "./InformationCard.vue?vue&type=style&index=0&id=65d61d6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d61d6a",
  null
  
)

export default component.exports